import React from 'react';
import { PricingPlans } from '../subscription/PricingPlans';

interface PricingSectionProps {
  onSignUp: () => void;
}

export function PricingSection({ onSignUp }: PricingSectionProps) {
  return (
    <div id="pricing-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 pt-32">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-white mb-4 font-['Sora']">Choose Your Plan</h2>
        <p className="text-xl text-gray-300 max-w-3xl mx-auto">
          Find the right plan for your workflow and start making your ideas happen.
        </p>
      </div>

      <PricingPlans initialBillingInterval="month" isLandingPage={true} onSignUp={onSignUp} />
    </div>
  );
}
